"use client";

import { Info } from "lucide-react";

import SchoolDetailSalaryScheduleLink from "@/components/shared/school/school-details/school-detail-salary-schedule-link";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { SchoolDetailSalaryScheduleProps } from "@/lib/types/schools.types";

export default function SchoolDetailSalarySchedule({
  salaryScheduleLink,
  schoolId,
  attribution,
}: SchoolDetailSalaryScheduleProps) {
  return (
    <span className="inline-flex items-center gap-1.5">
      <SchoolDetailSalaryScheduleLink
        salaryScheduleLink={salaryScheduleLink}
        schoolId={schoolId}
      />
      {attribution && (
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              aria-label={`Provided by ${attribution.name}`}
              className="inline-flex items-center text-ink-subtle hover:text-info focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-info/30 rounded-sm transition-colors"
            >
              <Info className="h-3.5 w-3.5" aria-hidden="true" />
            </button>
          </TooltipTrigger>
          <TooltipContent side="top" sideOffset={6} className="max-w-[220px]">
            <span>Provided by </span>
            <a
              href={attribution.url}
              target="_blank"
              rel="noopener noreferrer"
              className="underline underline-offset-2"
            >
              {attribution.name}
            </a>
          </TooltipContent>
        </Tooltip>
      )}
    </span>
  );
}
